import React,{useState,useEffect} from 'react';
import { motion } from 'framer-motion';
import { urlFor,client } from '../../Client';
import './About.scss';
import AppWrap from '../../wrapper/AppWrap';
import MotionWrap from '../../wrapper/MotionWrapper';
import { Typography } from '@mui/material';
import { NavLink } from 'react-router-dom';
import Stack from '@mui/material/Stack';
import Button from '@mui/material/Button';
import { Outlet } from "react-router-dom";
import aboutImg from '../../assets/img/about01.png';
import AboutMe from './AboutMe';
import Experience from './Experience';
import Skill from './Skill';

const About = () => {
    const [about,setAbout] = useState('about');
    return (
        <div>
        <div className='title-section'>
            <h1 className="text-secondary">about <span>me</span></h1>
            <span className='title-bg'>resume</span>
        </div>
        <div className="container aboutContent" style={{ width: '100%' }}>
            <div className="row">
                <div
                    style={{ zIndex: 1, padding: '2rem' }} className="col-sm-12  col-md-5">
                    <div className="aboutImgContainer" >
                        <img className='img-fluid  border' width='100%' src={aboutImg} alt='img' data-aos='zoom-in' />
                    </div>
                </div>
                <div className="col-sm-12, col-md-7">
                    <div data-aos='slide-right'>
                        <Stack
                            sx={{ justifyContent: 'center', mb: 4, }}
                            spacing={3}
                            direction="row">
                            {/* <NavLink
                                to='/home/about/about_me'
                                style={({ isActive }) => {
                                    return {
                                        backgroundColor: isActive ? "#1976d247" : ""
                                    };
                                }}> */}
                                <Button
                                style = {{backgroundColor: about ==='about' ? "#1976d247" : ""}}
                                 onClick={()=>setAbout('about')}
                                    sx={{
                                        fontWeight: 'bold',
                                    }}
                                    variant="outlined">about</Button>
                            {/* </NavLink> */}
                            {/* <NavLink
                                to='/home/about/skill'
                                style={({ isActive }) => {
                                    return {
                                        backgroundColor: isActive ? "#1976d247" : ""
                                    };
                                }}> */}
                                <Button onClick={()=>setAbout('skill')}
                                style = {{backgroundColor: about ==='skill' ? "#1976d247" : ""}}
                                    sx={{
                                        fontWeight: 'bold',
                                    }}
                                    variant="outlined">skill</Button>
                            {/* </NavLink> */}
                            {/* <NavLink
                                to='/home/about/experience'
                                style={({ isActive }) => {
                                    return {
                                        backgroundColor: isActive ? "#1976d247" : ""
                                    };
                                }}>
                                <Button
                                    sx={{
                                        fontWeight: 'bold',
                                    }}
                                    variant="outlined">experience</Button>
                            </NavLink> */}
                        </Stack>
                    </div>
                    <div data-aos='slide-up'>
                        {about==='about' && <AboutMe/>}
                        {about==='skill' && <Skill/>}
                        {/* <Outlet /> */}
                    </div>
                </div>
            </div>
        </div>
    </div >
    );
};

export default AppWrap(
    MotionWrap(About, 'app__about'),
    'about',
    'app__whitebg',
  );